// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Tags/TagsPicker/Content/mutation-update-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm_Content_Content_Tags_TagsPicker_Content($id: uuid!, $name: String!) {
  update_tasks_tags_by_pk(pk_columns: { id: $id }, _set: { name: $name }) {
    id
  }
}

`